import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import {BackEndRoutes} from "../../../../config/back-end-routes";
import {api} from "../../../../config/api";


interface AddPaymentTermModalProps {
    show: boolean;
    onHide: () => void;
    onSave: () => void;
    term?: any;
}

const AddPaymentTermModal: React.FC<AddPaymentTermModalProps> = ({ show, onHide, onSave, term }) => {
    const [data, setData] = useState<any>(term || { descricao: "", status: 1 });

    const handleSave = () => {
        const isEdit = !!data.id_prazo;
        const url = isEdit
            ? BackEndRoutes.routes.PRAZOS_PAGAMENTOS.FIND.replace(":id", data.id_prazo)
            : BackEndRoutes.routes.PRAZOS_PAGAMENTOS.CREATE;

        const method = isEdit ? "put" : "post";

        api[method](url, data)
            .then(() => {
                toast.success(`Prazo de pagamento ${isEdit ? "editado" : "adicionado"} com sucesso!`);
                onSave();
                onHide();
            })
            .catch(() => {
                toast.error("Erro ao salvar prazo de pagamento.");
            });
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{data.id_prazo ? "Editar Prazo" : "Adicionar Prazo"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="descricao">
                        <Form.Label>Descrição</Form.Label>
                        <Form.Control
                            type="text"
                            value={data.descricao}
                            onChange={(e) => setData({ ...data, descricao: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group controlId="status" className="mt-3">
                        <Form.Label>Status</Form.Label>
                        <Form.Select
                            value={data.status}
                            onChange={(e) => setData({ ...data, status: Number(e.target.value) })}
                        >
                            <option value={1}>Ativo</option>
                            <option value={0}>Inativo</option>
                        </Form.Select>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancelar
                </Button>
                <Button variant="primary" onClick={handleSave}>
                    Salvar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddPaymentTermModal;
